export interface Option {
  value: string
  label: string
}

export const setSelectOptions = (
  arr: Array<{ key: string; name: string }>,
): Option[] => arr.map(({ key, name }) => ({ value: key, label: name }))
